import api from '@/api';

import { API_BASE_URL } from '..'; // operational/v1
import { CreateAreaRequest } from '../Areas/Areas.types';
import {
  CreateSubAreaResponse,
  ListSubAreasQuery,
  UpdateSubAreaRequest,
  subAreaResponse,
} from './SubAreas.types';

const CONTROLLER_URL = `${API_BASE_URL}/subareas`;

export async function deleteSubArea(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function subAreaByAreaId(
  params: ListSubAreasQuery,
): Promise<subAreaResponse> {
  const result = (await api.get(
    `${CONTROLLER_URL}/area/${params.id}`,
    params,
  )) as unknown;

  return result as subAreaResponse;
}

export async function createSubArea(
  obj: CreateAreaRequest,
): Promise<CreateSubAreaResponse> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as CreateSubAreaResponse;
}

export async function updateSubArea(
  obj: UpdateSubAreaRequest,
): Promise<CreateSubAreaResponse> {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as CreateSubAreaResponse;
}
